import { VStack, Divider, Circle, Text, Button, Icon, useDisclosure } from '@chakra-ui/react';

import groupHostInfoAtom from '~/recoil/atom/groupHostInfo';
import { useRecoilValue } from 'recoil';
import { IoMailOpenOutline } from 'react-icons/io5';

import LeaveOrCancelGroupModal from '~/components/LeaveOrCancelGroupModal';

export default function MemberContent() {
  const groupHostInfo = useRecoilValue(groupHostInfoAtom);

  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <VStack m="auto" align="stretch" maxW="300px">
      <Circle m="auto" bgColor="#FFF9EF" size="14">
        <Icon as={IoMailOpenOutline} color="secondary" boxSize="1.5rem" />
      </Circle>
      <Text textAlign="center" fontSize="lg" fontWeight="bold">
        歡迎來到蔬氧VO2點餐網站
      </Text>
      <Text textAlign="center" fontSize="sm">
        {groupHostInfo.name}邀請您揪團點餐
      </Text>
      <Divider borderColor="gray.400" />
      {groupHostInfo.note && (
        <>
          <Text fontWeight="bold" fontSize="sm">
            團長的話
          </Text>
          <Text borderRadius="4px" bgColor="gray.200" p={2} fontSize="xs">
            {groupHostInfo.note}
          </Text>
        </>
      )}
      <Button
        variant="unstyled"
        fontWeight="normal"
        fontSize="sm"
        onClick={onOpen}
        color="secondary"
      >
        離開揪團
      </Button>

      <LeaveOrCancelGroupModal isOpen={isOpen} onClose={onClose} isHost={false} />
    </VStack>
  );
}
